module.exports = __webpack_public_path__ + "img/bigwin-text.f2835c6a.png";